import { Clock, RefreshCw, CheckCircle2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { TenantStatusScreen } from "@/components/TenantStatusScreen";
import { useTenantRecheck } from "@/hooks/useTenantRecheck";

export default function Expired() {
  const { t } = useLang();
  const { status, recheckNow } = useTenantRecheck("expired");
  return (
    <TenantStatusScreen
      icon={Clock}
      tone="amber"
      title={t("tenantStatus.expiredTitle")}
      body={t("tenantStatus.expiredBody")}
      hint={t("tenantStatus.contact")}
      testid="tenant-expired-page"
      footer={<RecheckFooter status={status} recheckNow={recheckNow} t={t} />}
    />
  );
}

function RecheckFooter({ status, recheckNow, t }) {
  if (status === "reconnected") {
    return (
      <p className="flex items-center gap-2 text-sm font-medium text-emerald-600" data-testid="tenant-reconnected">
        <CheckCircle2 size={16} /> {t("tenantStatus.reconnected")}
      </p>
    );
  }
  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={recheckNow}
        disabled={status === "checking"}
        data-testid="tenant-recheck-button"
        className="inline-flex items-center gap-2 rounded-sm border border-zinc-200 px-3.5 py-2 text-sm font-medium text-zinc-700 transition-colors hover:bg-zinc-50 disabled:opacity-60"
      >
        <RefreshCw size={15} className={status === "checking" ? "animate-spin" : ""} />
        {t("tenantStatus.recheckNow")}
      </button>
      <span className="font-mono text-xs uppercase tracking-wider text-zinc-400">
        {t("tenantStatus.rechecking")}
      </span>
    </div>
  );
}
